<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Telefoonnummer beëindigen"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-form-row id="phoneNumber" label="telefoonnummer" type="string" v-model="payloadData.phoneNumber"
                       key="phoneNumber"
                       :requiredField="true"
                       disabled="true"></dean-form-row>
      </fade-transition>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {FadeTransition} from 'vue2-transitions';
import {getErrorCodeFromResponse, getErrorMessageFromResponse, getErrorMessageFromTranslationByErrorCode} from "@/mixins/errorMessage";

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class ProvisionServicesDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      this.$emit('setLoad', true);
      axios.post('/-/trade/api/provisioning.terminate.phoneNumber', {
        partitionId: this.payloadData.partitionId,
        phoneNumber: this.payloadData.phoneNumber,
      }).then(
        (response: any) => {
          deanDialogBus.$emit('saved');
          this.$toast(this.$store.state.main.notification.messages.dataSaved);
          this.close();
        },
        (error: any) => {
          const errorResponse = error.response.data;
          const errorCode: string|null = getErrorCodeFromResponse(errorResponse);
          let errorMessage: string|null|any = null;

          if (errorCode) {
            errorMessage = getErrorMessageFromTranslationByErrorCode(errorCode);
          }

          if (null === errorMessage) {
            errorMessage = getErrorMessageFromResponse(errorResponse, this.$store.state.main.notification.messages.couldNotSendData.text);
          }

          if (errorMessage) {
            this.$toast({
              icon: warningIcon,
              title: 'Waarschuwing',
              text: errorMessage,
              theme: 'warning',
            });
          } else {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          }
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 500px;
}

</style>
